export const header = () => {


	//Hide the header as the users scrolls down, reveal it again if they scroll up
	let pageHeader = document.querySelector('#main-header');

	if(pageHeader){
		let scrollTrigger = 150; //Artbiary height in PX

		//Run check on page load
		if(window.scrollY > scrollTrigger){
			pageHeader.classList.add('header-scrolled');
		}

		document.addEventListener('scroll', (event) => {

			if(window.scrollY > scrollTrigger){
				pageHeader.classList.add('header-scrolled');
			}else{
				pageHeader.classList.remove('header-scrolled');
				
			}
			
		 		
		});
	}
	

	
}